import React from "react";
import { Product } from "../../../../application/domain/help/help-entity";
import { CategoryProps, HelpCategoryTitle, HelpContentLink } from "./category";
import "./product-search-function.scss";
import {
  ProductBoxProps,
  useProductSearchFunctionController,
} from "./use-product-search-function-controller";

const ProductBox: React.FC<ProductBoxProps> = ({ data }) => {
  return (
    <>
      {data.contentList.length > 0 ? (
        <div className="help-search-function-content-box">
          <p className="help-product-name">{data.product.title}</p>
          <ul className="help-search-function-content-link-box">
            {data.contentList.map((content) => (
              <li key={content.slug}>
                <HelpContentLink
                  content={content}
                  className="help-search-function-content-link"
                />
              </li>
            ))}
          </ul>
          <div className="help-function-list-box">
            <a
              className="help-function-list-link"
              href={`/help/${data.product.id}`}
            >
              もっと見る
            </a>
          </div>
        </div>
      ) : null}
    </>
  );
};

export const ProductSearchFunction: React.FC<
  CategoryProps & {
    productList: Product[];
  }
> = (props) => {
  const { category, contentList } = useProductSearchFunctionController(props);

  return category && category.metadata.children.length > 0 ? (
    <div className="help-search-function-content-box">
      <HelpCategoryTitle category={category} />
      <div className="help-search-function-content">
        {contentList?.map((content) => {
          return <ProductBox key={content.product.id} data={content} />;
        })}
      </div>
    </div>
  ) : null;
};
